"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseStyle = {
    textColor: "white",
    subTextColor: "grey",
    highlightColor: "orange",
    backgroundColor: "#262626",
    backgroundColorLight: "rgb(102, 102, 102)"
};
